import React from 'react';

// Per-group header icon + accent color, keyed by group key. Purely visual cue;
// each group gets a distinct color (left strip + faint tint + icon).
export const GROUP_META = {
  status: { icon: 'pi-check-circle', color: '#16a34a' },
  competition: { icon: 'pi-users', color: '#2563eb' },
  sellers: { icon: 'pi-shopping-bag', color: '#5b6472' },
  dropshipping: { icon: 'pi-truck', color: '#0891b2' },
  // pi-truck is the dropshipping group's; a supplier is who we buy FROM, so a box.
  supplier: { icon: 'pi-box', color: '#ea580c' },
  compliance: { icon: 'pi-shield', color: '#f59e0b' },
  template: { icon: 'pi-clone', color: '#7c3aed' },
  classification: { icon: 'pi-tags', color: '#db2777' },
  priceRange: { icon: 'pi-calendar', color: '#0d9488' },
  // Marketplace operator: cheaper-on / diff % / 1P filters.
  marketplace: { icon: 'pi-globe', color: '#4f46e5' },
};

// Inline expanding panel; groups are profile-aware. groups: [{key,label,render()}].
export default function ProductFilterPanel({ t, visible, groups, onClose }) {
  if (!visible) return null;
  return (
    <div className="pux-filter" style={{ border:'1px solid #e5e7eb', borderRadius:10, padding:16, marginBottom:12, background:'#fafbfc' }}>
      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12 }}>
        <strong>{t('product.filter')}</strong>
        <button type="button" className="pux-fchip" style={{ cursor:'pointer' }} onClick={onClose}><i className="pi pi-times" /></button>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(200px, 1fr))', gap:12, alignItems:'start' }}>
        {groups.map(g => {
          const meta = GROUP_META[g.key];
          const accent = meta ? { borderColor: meta.color + '40', background: meta.color + '0c', boxShadow: `inset 3px 0 0 ${meta.color}` } : undefined;
          return (
            <div key={g.key} className="pux-filter-group" style={accent}>
              <div className="pux-filter-group-title">
                {meta && <i className={`pi ${meta.icon}`} style={{ color: meta.color }} />}
                {g.label}
              </div>
              {g.render()}
            </div>
          );
        })}
      </div>
    </div>
  );
}
